import React from 'react';

type Props = {
    fillColor?: string;
    width?: number;
    height?: number;
};

const SmartSearchIcon = React.memo(function SmartSearchIcon({
    fillColor = '#fff',
    width = 14,
    height = 17,
}: Props) {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 18 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5.3101 3.29972L6.05595 5.06071L6.81876 3.29972L8.6495 2.47906L6.81876 1.67551L6.05595 0L5.3101 1.67551L3.47937 2.47906L5.3101 3.29972ZM0.25 9.5C0.25 7.41674 1.22992 5.56247 2.75399 4.37294L3.76695 6.12744C2.83592 6.95117 2.25 8.15562 2.25 9.5C2.25 11.99 4.26 14 6.75 14C9.24 14 11.25 11.99 11.25 9.5C11.25 8.86022 11.1173 8.25213 10.8779 7.70168L12.6167 6.69778C13.0227 7.54627 13.25 8.49657 13.25 9.5C13.25 11.11 12.66 12.59 11.68 13.73L11.96 14H12.75L17.74 19L16.25 20.49L11.25 15.5V14.71L10.98 14.43C9.84 15.41 8.36 16 6.75 16C3.16 16 0.25 13.09 0.25 9.5ZM11.5882 5.53322L11.0614 4.30376L9.76843 3.7308L11.0614 3.16978L11.5882 2L12.1269 3.16978L13.4199 3.7308L12.1269 4.30376L11.5882 5.53322ZM7.06142 9.30376L7.58819 10.5332L8.12694 9.30376L9.41993 8.7308L8.12694 8.16978L7.58819 7L7.06142 8.16978L5.76843 8.7308L7.06142 9.30376Z"
                fill={fillColor}
            />
        </svg>
    );
});

export default SmartSearchIcon;
